import {
  BaseMediaListResponse,
  BaseMediaResponse, BasePornActressListResponse, BasePornActressResponse,
  BasePornCategoryListResponse, BasePornTagListResponse,
  BaseResponse,
  PornViewData,
} from '@api/backend';
import { Observable } from 'rxjs';

export abstract class PornRepository {

  public abstract getCategories(): Observable<BasePornCategoryListResponse>;

  public abstract getTags(): Observable<BasePornTagListResponse>;

  public abstract getList(params: {
    t?: string, c?: string, r?: string, a?: string, q?: string, p?: number,
  }): Observable<BaseMediaListResponse>;

  public abstract getById(mediaId: string): Observable<BaseMediaResponse>;

  public abstract like(media_id: string): Observable<BaseResponse>;

  public abstract unlike(media_id: string): Observable<BaseResponse>;

  public abstract share(media_id: string): Observable<BaseResponse>;

  public abstract view(mediaId: string, view: PornViewData): Observable<BaseResponse>;

  public abstract getStars(params: {
    piercing?: boolean, tattoo?: boolean, silicone?: boolean, assSize?: string, waistSize?: string,
    breastSize?: string, height?: string, weight?: string, age?: string, q?: string, r?: string, p?: number,
    pageSize?: number }
  ): Observable<BasePornActressListResponse>;

  public abstract getStarById(id: string): Observable<BasePornActressResponse>;
}